// extracted by mini-css-extract-plugin
export default {"text":"NoResults-text-x6I"};